<template>
  <div>
    <modal :show.sync="modals.modal0" id="cadastrar-seções">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Cadastrar Descontos</h5>
      </template>
      <validation-observer ref="observer">
        <form role="form">
          <div class="row">
            <div class="col-md-12">
              <base-input 
                label="Nome" 
                placeholder="Nome do desconto"
                v-model="discount.name"
                :required="true"
                name="name"
              />
            </div>
            <div class="col-md-12">
              <base-input 
                label="Porcentagem" 
                placeholder="5"
                v-model="discount.percentage"
                :required="true"
                name="percentage"
                append-icon="fa fa-percent"
              />
            </div>
          </div>
        </form>
      </validation-observer>
      <template slot="footer">
        <base-button type="secondary" @click="modals.modal0 = false">Fechar</base-button>
        <base-button type="success" @click="save">Salvar</base-button>
      </template>
    </modal>
    <card>
      <div slot="header">
        <div class="row">
          <div class="col-md-10">
            <span>Desconto gerais</span>
          </div>
          <div class="col-md-2">
            <base-button
              @click="modals.modal0 = true"
              type="neutral"
              class="ml-3"
              size="sm"
            >
              Cadastro
            </base-button>
          </div>
        </div>
      </div>
      <form>
        <div class="row">
          <div class="col-md-10">
            <div>
             <base-input 
                label="Nome" 
                placeholder="Nome do Desconto"
                v-model="filter.name"
              />
            </div>
          </div>
          <div class="col-md-2">
            <div style="margin-top: 2rem">
              <base-button icon type="primary" v-on:click="search">
                <span class="btn-inner--icon">
                  <i class="fa fa-search"></i>
                </span>
                <span class="btn-inner--text">Pesquisar</span>
              </base-button>
            </div>
          </div>
        </div>
      </form>
      <el-table
        class="table-responsive table-striped clickable-rows"
        header-row-class-name="thead-light"
        :data="discounts"
        @row-click="rowClicked"
        ref="discounts"
      >
        <el-table-column label="Nome" prop="name" sortable/>
        <el-table-column label="Porcentagem" prop="percentage" sortable/>
        <el-table-column 
          label="Ações" 
          width="120" 
          prop="acoes" 
          v-slot="{row}">
          <div class="row">
            <el-dropdown trigger="hover" class="dropdown" style="cursor: pointer;">
              <span class="btn btn-sm btn-icon-only text-success">
                <i class="fas fa-ellipsis-v mt-2"></i>
              </span>
              <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                <a class="dropdown-item" href="#" @click="edit(row)">Editar</a>
                <a class="dropdown-item" href="#" @click="remove(row)">Excluir</a>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-table-column>
      </el-table>
      <div slot="footer" class="py-4 d-flex justify-content-end">
        <base-pagination
          v-on:input="changePage"
          v-model="paginated_data['current']"
          :total="paginated_data['count']"
          :perPage="paginated_data['per_page']"
        ></base-pagination>
      </div>
    </card>
  </div>
</template>
<script>
import Vue from "vue";
import { Select, Option } from 'element-ui'
import { 
  Table, 
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown  
} from "element-ui";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";




export default {
  name: "default-discounts",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  props: {
    campaign: Object
  },
  data() {
    return {
      modals: {
        modal0: false
      },
      discounts: [],
      discount: {},
      discount_types: [],
      filter: {},
      errors: [],
      // flag de verificação se foi pesquisado algo
      filtered: false,
      paginated_data: [],
      formData: {},
    }
  },
  mounted() {
    this.setStaticData();
    // this.$root.$on('new_discount', (tabName) => {
    //   if(tabName != 'general') return;
      
    //   this.newDiscount();
    // })
  },
  methods: {
    rowClicked(row) {
      this.$refs.discounts.toggleRowExpansion(row);
    },
    setError(error, text) {
      this.error =
        (error.response && error.response.data && error.response.data.error) ||
        text;
    },
    setData(q, page) {
     //  Adicionando valores default a query e ao número da página se não definidos
      // console.log('antes');
      // console.log(q);
      if (typeof page === "undefined") page = null;
      if (typeof q === "undefined" || this.emptyFilter) q = null;
    
      // console.log('depois');
      // console.log(q);

      this.$http.secured
        .get(`/api/v1/campaigns/${this.campaign.id}/discounts`, {
          params: {
            discount_type: "campaign_default",
            campaign_id: this.campaign.id,
            page: page,
            q: q
          }
        })
        .then(response => {
          // setando dados de paginação e a collection produtos
          this.paginated_data       = response.data;
          this.discounts            = this.paginated_data["discounts"];
          this.discount.campaign_id = this.campaign.id
          this.discount.discount_type = "campaign_default"
        })
        .catch(error => this.setError(error, "Something went wrong"));

    },
    setStaticData(){
      this.setDiscountTypes();
    },
    newDiscount(){
      console.log("To aqui")
      this.modals.modal0 = true;
    },
    setDiscountTypes() {
      this.$http.secured
      .get("/api/v1/discounts/discount_types")
      .then(response => {
        this.discount_types = response.data;
      })
      .catch(error => this.setError(error, "failed to fetch branches"));
    },
    search() {      
      // // a flag filtered é verdadeira quando algo é pesqusado
      // // No caso se os campos de pesquisa estão vazios ela é falsa
      this.filtered = !this.emptyFilter;
      this.setData(this.normalizedFilter);
      // console.log('Filter: ', {...this.normalizedFilter})
    },
    changePage(page) {
      let filterInput = null;

      if (this.filtered) filterInput = this.filter;
      // Se algo foi pesquisado passa o parametro de filtro
      // Se não é passado parâmetro nulo
      this.setData(filterInput, page);
    },
    async save() {
     const validForm = await this.$refs.observer.validate()
      if(!validForm) {
        console.log("invalid Form");
        return;
      }

      this.$http.secured(this.reqParams)
        .then(response => {
          console.log("response: ",response.data)
          this.$toasted.global.defaultSuccess();
          this.setData();
          this.modals.modal0 = false;
          this.resetInputs()
          this.$refs.observer.reset();
        })
        .catch(error => {
          this.setError(error, "Cannot save Sector")
          this.$refs.observer.setErrors(this.errors)
        });
    },
    edit(discount) {
      this.discount = discount
      this.modals.modal0 = true
    },
    remove(discount){
      this.$http.secured
        .delete(`/api/v1/campaigns/${this.campaign.id}/discounts/${discount.id}`, discount)
        .then(response => {
          console.log("response: ",response.data)
          this.$toasted.global.defaultSuccess();
          this.setData();
        })
        .catch(error => {
          this.setError(error, "Cannot remove discount")
          this.$refs.observer.setErrors(this.errors)
        });
    },
    resetInputs() {
      this.filter = {}
      this.discount = {}
      this.marker = {}
    }
  },
  computed: {
    reqParams: function() {
      if(this.discount.hasOwnProperty('id')) {
        return {
          url: `/api/v1/campaigns/${this.campaign.id}/discounts/${this.discount.id}`,
          method: 'patch',
          data: this.discount,
        }
      }

      return { 
        url: `/api/v1/campaigns/${this.campaign.id}/discounts`,
        method: 'post',
        data: this.discount,
      }   
    },
    emptyFilter: function() {
      for (var key in this.filter) {
        if (
          this.filter.hasOwnProperty(key) &&
          this.filter[key] != "" &&
          typeof this.filter[key] != "undefined"
        ) {
          return false;
        }
      }
      return true;
    },
    normalizedFilter: function(){
      let filter = this.filter;
      for(let key in filter){
        // replacing objects by ids
        if (
          filter.hasOwnProperty(key) &&
          typeof filter[key] == 'object'
        ) {
          if(filter[key].hasOwnProperty('id')){
            filter[key + '_id'] = filter[key].id
            delete filter[key]
          } else {
            filter[key] = filter[key].value
          }
        }
        // removing empty fields
        if (filter[key] == "") {
          delete filter[key];
        }
      }

      return filter;
    },
  }, 
  watch: {
    campaign: function(value) {
      this.setData()
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>

